const displayMappingsFromGroupLabel = {
	group: {
		interfaceType: {
			slider: [ 1 ],
			overflow: [ 2 ]
		}
	},
	displayOptions: {
		maxItemsPerRow: {
			4: [ 'Finish', 'Height', 'Number of Lights', 'Color' ],
			5: []
		},
		showThumbnail: [ 'Finish', 'Color' ],
		showRoundedButton: [ 'Height', 'Number of Lights' ],
		showPrice: [ 'Number of Lights' ],
		showLabel: [ 'Finish', 'Color', 'Number of Lights', 'Height' ],
		displayArea: {
			insideButton: [ 'Height', 'Number of Lights' ],
			outsideButton: [ 'Finish', 'Color' ]
		}
	}
};

export default displayMappingsFromGroupLabel;
